import { QRCodeCanvas } from 'qrcode.react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable, DataTableExpandedRows, DataTableFilterMeta } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { useToast } from '../../../components/Toast';
import { Dropdown } from 'primereact/dropdown';
import BreadcrumbComponent from '../../../components/Breadcrumb';
import "jspdf-autotable";
import { TieredMenu } from "primereact/tieredmenu";
import { exportExcel, exportQrPDF } from "../../../components/Export";
import qrService from './qr-service';
import { Sidebar } from 'primereact/sidebar';
import { Fieldset } from 'primereact/fieldset';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    'fullName': {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    representative: { value: null, matchMode: FilterMatchMode.IN },
    date: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    balance: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    status: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
};

interface RecordFilter {
    [key: string]: string | boolean | Date | null; // Adjust types as needed
}

const QRList: React.FC = () => {
    const [gridDataSource, setGridDataSource] = useState<any[]>([]);
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const navigate = useNavigate();
    const [clientState, setClientState] = useState<any>(null);
    const [isValid, setIsValid] = useState<boolean>(true);
    const { showToast } = useToast();
    const menuRef = useRef<TieredMenu>(null);
    const location = useLocation();
    const [recordFilter, setRecordFilter] = useState<RecordFilter>({
        dateFrom: new Date(),
        dateTo: new Date(),
        searchValue: '',
        searchBy: "",
    });

    const searchByOptions = [
        { label: 'Serial Number', value: 'snNo' },
        { label: 'Item Description', value: 'itemDesc' },
        { label: 'Manufacturer Name', value: 'manufacturerName' },
        { label: 'Installation Location', value: 'installationLocation' },
        { label: 'Generated By', value: 'insertBy' },
    ]
    const toast = useRef<Toast>(null);

    const [shouldFetch, setShouldFetch] = useState<boolean>(false);

    const [noOfQr, setNoOfQr] = useState<any>(null);


    const [ASTQrdetInit, setASTQrdetInit] = useState<any[] | DataTableExpandedRows>([]);
    const [ASTQrdet, setASTQrdet] = useState<Record<string, any[]>>({});

    const [isPopupVisible, setIsPopupVisible] = useState(false);

    const [printerName, setPrinterName] = useState<string>("");



    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await qrService.getClientState();
                setClientState(clientStateItem);

                const result = await qrService.getPrinterName("PRINTER_NAME");

                setPrinterName(result.parameterValue);

                const searchParam = await qrService.getSearchParam(location.pathname);
                if (searchParam) {
                    setRecordFilter(searchParam.recordFilter);
                }

            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

    useEffect(() => {
        if (clientState) {
            const fetchUserList = async () => {

                if (recordFilter?.dateFrom !== null && recordFilter?.dateTo !== null) {
                    if (recordFilter?.dateFrom > recordFilter?.dateTo) {
                        setIsValid(false);
                    } else {
                        setIsValid(true);

                    }
                }

                try {
                    if (recordFilter.searchValue && recordFilter.searchBy) {
                        if (recordFilter.searchBy !== "insertBy") {
                            recordFilter.dateFrom = null;
                            recordFilter.dateTo = null;
                        }
                    }

                    recordFilter.country = clientState.country;

                    qrService.setSearchParam(recordFilter, location.pathname);

                    qrService.findAll(recordFilter).then((data) => {
                        if (data) {
                            setGridDataSource(data);
                        } else {
                            setGridDataSource([]);
                        }


                        setShouldFetch(false);
                    });
                } catch (error) {
                    showToast(clientState.error);
                }
            };

            fetchUserList();
        }
    }, [clientState, shouldFetch]);

    // useEffect(() => {
    //     if (clientState) {
    //         const fetchUserList = async () => {
    //             if (recordFilter?.dateFrom !== null && recordFilter?.dateTo !== null) {
    //                 if (recordFilter?.dateFrom > recordFilter?.dateTo) {
    //                     setIsValid(false);
    //                     return;
    //                 }
    //                 setIsValid(true);

    //                 try {
    //                     // BUAT salinan, JANGAN mutate state
    //                     const payload: any = { ...recordFilter };

    //                     if (payload.searchValue && payload.searchBy) {
    //                         payload.dateFrom = null;
    //                         payload.dateTo = null;
    //                     }

    //                     qrService.setSearchParam(payload, location.pathname);

    //                     const data = await qrService.findAll(payload);
    //                     setGridDataSource(data);
    //                 } catch (error) {
    //                     showToast(clientState.error);
    //                 } finally {
    //                     // optional bila guna toggle, tapi selamat untuk reset
    //                     setShouldFetch(false);
    //                 }
    //             }
    //         };

    //         fetchUserList();
    //     }
    // }, [clientState, shouldFetch]); 


    useEffect(() => {
        const fetchReferenceCodes = async () => {
            if (typeof ASTQrdetInit === 'object' && !Array.isArray(ASTQrdetInit)) {
                for (const key of Object.keys(ASTQrdetInit)) {
                    if (ASTQrdetInit[key]) {
                        qrService.findAllQRdet(key).then((data) => {
                            setASTQrdet((prev) => ({
                                ...prev,
                                [key]: data,
                            }));
                        });
                    }
                }
            }
        };

        fetchReferenceCodes();
    }, [ASTQrdetInit]);


    function handleCreate(): void {
        setIsPopupVisible(true);
        setNoOfQr(0);

    }

    const handleEdit = (item: any) => {
        navigate('/machine/qr-edit', { state: { selectedItem: item } });
    };

    const handleView = (item: any) => {
        navigate('/machine/qr-view', { state: { selectedItem: item } });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters(defaultFilters);
        setGlobalFilterValue('');
    }

    const handleClosePopup = () => {
        setIsPopupVisible(false);  // Reset the item
    };

    const renderQRCode = (rowData: any) => {
        return (
            <div className="flex justify-center p-4">
                <QRCodeCanvas value={rowData.qrValue} size={60} />
            </div>
        );
    };

    // printerName: get from your state, or pass as parameter if needed
    const printQRLabelZPL = async (qrValue: string, entity: string, printerName: string) => {
        function formatEntity(entity: any) {
            return entity.replace(" (", "\\& (");
        }

        const formattedEntity = formatEntity(entity);

        //printer zebra use this
        const zpl = `
           ^XA
^PW320
^LL240
^MD30
^PR4
^LH0,0

^FX ================= QR CODE =================
^FX QR approx 184x184. Center Point: X=160, Y=107
^FO79,15
^BQN,2,4,H
^FDHA,${qrValue}^FS

^FX ================= LOGO BACKGROUND (ERASER) =================
^FX Size: 52x52 dots (Tighter fit for a 40x40 logo)
^FX X: 160 (Center) - 26 (Half Width) = 134
^FX Y: 107 (Center) - 26 (Half Height) = 81
^FO140,81
^GB52,52,52,W,3^FS

^FX ================= LOGO OVERLAY =================
^FX NOTE: The logo canvas is 64x64, we center it at X=160 - 32 = 128
^FO140,79
^GFA,378,378,7,,,,L01,L01E,L01F,L01F8,L01F8,L01FC,L01FC,L01FC,L01FC,L01FC,L01FC,L01F8,L01F8,L01F,L01F,L01E,L01E,01FE001C01FC,03FF801C07FF,07FFE0181IF800JF0107IF800JFC10JFC00KF03JFC01KFCKFC0,L01,L01,L01,L018,L01C,L01C,L01E,L01F,L01F,L01F,L01F8,L01F8,L01FC,L01FC,L01FC,L01FC,L01FC,L01FC,L01F8,L01F,L01F,L01C,,,,,
^FS

^FX ================= TEXT =================
^FO62,192
^FB200,5,0,C
^A0N,25,25
^FD${formattedEntity}^FS

^XZ

            `;


        //printer TSC use this
        // const zpl = `
        //         ^XA
        //         ^FO320,23
        //         ^BQN,2,9
        //         ^FDLA,${qrValue}^FS
        //         ^XZ
        //           `;
        const item = {
            labelCode: zpl,
            printerName: printerName
        };
        // await qrService.print(item);

        const response = await fetch('http://localhost:3006/print', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ labelCode: zpl, printerName }),
        });
    };


    const handlePrintBundle = async (qrBatchId: string) => {
        const data = await qrService.findAllQRdet(qrBatchId);

        if (!data.length) {
            toast.current?.show({
                severity: 'warn',
                summary: 'No QRs',
                detail: 'No QR codes found in this batch.',
            });
            return;
        }

        let error: any = null;

        for (const qr of data) {
            try {
                await printQRLabelZPL(qr.qrValue, qr.entity, printerName);
            } catch (err: any) {
                if (!error) error = err;
            }
        }

        if (error) {
            toast.current?.show({
                severity: 'error',
                summary: 'Print Error',
                detail: 'Printer not found or nova device offline',
            });
        } else {
            toast.current?.show({
                severity: 'success',
                summary: 'Printing',
                detail: `Printing ${data.length} QR codes.`,
            });
        }
    };





    const rowExpansionTemplate = (rowData: any) => {
        const data = ASTQrdet[rowData.qrBatchId] || [];

        const actionDetailTemplate = (rowData: any) => (
            <div style={{ display: 'flex', gap: '5px' }}>
                <Toast ref={toast} position="bottom-center" />
                <Button
                    label="Print QR"
                    icon="pi pi-qrcode"
                    className="p-button-warning p-button-sm"
                    style={{ padding: '5px 5px', fontSize: '10px' }}
                    // onClick={() => printQRLabelZPL(rowData.qrValue, printerName)}
                    onClick={async () => {
                        try {
                            await printQRLabelZPL(rowData.qrValue, rowData.entity, printerName);
                            toast.current?.show({
                                severity: 'success',
                                summary: 'Printing',
                                detail: 'Printing QR code.',
                            });
                        } catch (err: any) {
                            toast.current?.show({
                                severity: 'error',
                                summary: 'Print Error',
                                detail: 'Printer not found or nova device offline',
                            });
                        }
                    }}
                />
                {/* <Button
                label="View"
                icon="pi pi-eye"
                className="p-button-info p-button-sm "
                style={{ padding: '5px 5px', fontSize: '10px' }}
                onClick={() => handleView(rowData)}
            /> */}
            </div>
        );

        return (
            <div className="orders-subtable">
                <DataTable
                    value={data}
                    scrollable
                    scrollHeight="500px"
                    sortField="qrId"
                    sortOrder={1}
                >
                    <Column
                        header="No."
                        style={{ width: '5%' }}
                        body={(_, { rowIndex }) => rowIndex + 1}
                        headerClassName="list-header"
                    />
                    <Column body={actionDetailTemplate} header="Actions" style={{ width: '20%' }} headerClassName="list-header" ></Column>
                    <Column
                        field="qrValue"
                        header="QR"
                        body={(rowData) => renderQRCode(rowData)}
                        style={{ width: "20%" }}
                        headerClassName="list-header"
                    />
                    <Column field="qrId" header="QR Id" headerClassName="list-header" />
                    <Column field="assignBy" header="Assign By" style={{ width: "20%" }} headerClassName="list-header"></Column>
                    <Column field="assignDate" header="Assign Date" style={{ width: "20%" }}
                        body={(rowData) => rowData.assignDate
                            ? new Date(rowData.assignDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', })
                            : ''
                        } headerClassName="list-header">
                    </Column>
                    <Column field="instrumentIdHasOne.itemDesc" header="Instrument Name" style={{ width: "20%" }} headerClassName="list-header"></Column>
                    <Column field="instrumentIdHasOne.snNo" header="Instrument S/N" style={{ width: "20%" }} headerClassName="list-header"></Column>
                    <Column field="instrumentIdHasOne.itemCode" header="Instrument Code" style={{ width: "20%" }} headerClassName="list-header"></Column>
                    <Column field="instrumentIdHasOne.manufacturerName" header="Manufacturer Name" style={{ width: "20%" }} headerClassName="list-header"></Column>
                    <Column field="instrumentIdHasOne.lastPmDate" header="Last PM Date" style={{ width: "20%" }}
                        body={(rowData) => rowData.instrumentIdHasOne?.lastPmDate
                            ? new Date(rowData.instrumentIdHasOne.lastPmDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', })
                            : ''
                        } headerClassName="list-header">
                    </Column>
                    <Column field="instrumentIdHasOne.nextPmDate" header="Next PM Date" style={{ width: "20%" }}
                        body={(rowData) => rowData.instrumentIdHasOne?.nextPmDate
                            ? new Date(rowData.instrumentIdHasOne.nextPmDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', })
                            : ''
                        } headerClassName="list-header">
                    </Column>
                    <Column field="instrumentIdHasOne.entity" header="Entity" style={{ width: "20%" }} headerClassName="list-header"></Column>
                    <Column field="instrumentIdHasOne.installationLocation" header="Installation Location" style={{ width: "20%" }} headerClassName="list-header"></Column>
                    <Column field="instrumentIdHasOne.installDate" header="Install Date" style={{ width: "20%" }}
                        body={(rowData) => rowData.instrumentIdHasOne?.installDate
                            ? new Date(rowData.instrumentIdHasOne.installDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', })
                            : ''
                        } headerClassName="list-header">
                    </Column>
                    <Column field="instrumentIdHasOne.warrantyEndDate" header="Warranty End Date" style={{ width: "20%" }}
                        body={(rowData) => rowData.instrumentIdHasOne?.warrantyEndDate
                            ? new Date(rowData.instrumentIdHasOne.warrantyEndDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', })
                            : ''
                        } headerClassName="list-header">
                    </Column>
                </DataTable>
            </div>
        );
    };

    const dialogFooter = () => {

        function submit(): void {
            const currentDate = new Date().toLocaleString("en-US", { timeZone: clientState.timeZone });
            let entity = '';
            if (clientState.country === 'Malaysia') {
                entity = 'Biomed Global (MY)';
            } else if (clientState.country === 'Singapore') {
                entity = 'Biomed Global (SG)';
            } else if (clientState.country === 'Indonesia') {
                entity = 'PTBG Sinergi';
            }

            let item = {
                insertBy: clientState.fullName,
                insertDate: new Date(currentDate),
                modifiedBy: clientState.fullName,
                modifiedDate: new Date(currentDate),
                facilityCode: clientState.facilityCode,
                noOfQr: noOfQr,
                qrValue: process.env.REACT_APP_API_BASE_URL,
                country: clientState.country,
                entity: entity,
            }

            qrService.create(item).then(() => {
                setShouldFetch(true);
                clientState.success.detail = 'Already Save Record';
                toast.current?.show(clientState.success);
                handleClosePopup();
            }).catch((error) => {
                const errorMessage = error.response?.data?.message || 'Failed to create record.';
                clientState.error.detail = errorMessage;
                toast.current?.show(clientState.error);
            });
        }
        function handleBack(): void {
            handleClosePopup();
        }

        return (
            <>

                <Button label="Save" icon="pi pi-check" style={{ marginRight: '.5em' }} className="p-button-success" onClick={submit} />
                <Button label="Back" icon="pi pi-reply" style={{ marginRight: '.5em' }} onClick={() => handleBack()} />

            </>
        );
    };

    const header = () => {

        const formatDate = (date: any): string => {
            if (!date || typeof date === "boolean") return "Invalid Date";
            return new Date(date).toLocaleDateString("en-GB");
        };

        const fileName = `QR Generation ${formatDate(recordFilter?.dateFrom)} - ${formatDate(recordFilter?.dateTo)}`;

        const exportOptions: any[] = [
            {
                label: "Export to Excel",
                icon: "pi pi-file-excel",
                command: () => exportExcel(fileName),
            },
            {
                label: "Export to PDF",
                icon: "pi pi-file-pdf",
                command: () => exportQrPDF(fileName),
            },
        ];

        return (
            <div>
                <div className="flex justify-content-between">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '.3em' }}>
                        <span className="p-float-label">
                            <InputText type="text" id="inputtext" value={globalFilterValue} onChange={onGlobalFilterChange} />
                            <label htmlFor="inputtext">Keyword Search</label>
                        </span>
                    </div>
                    <div>
                        <TieredMenu model={exportOptions} popup ref={menuRef} />
                        {/* <Button label="Excel" icon="pi pi-file-excel" className="p-button-success" style={{ marginRight: '.5em' }} onClick={() => exportExcel(fileName)} /> */}
                        {/* <Button label="PDF" icon="pi pi-file-pdf" className="p-button-danger" style={{ marginRight: '.5em' }} onClick={() => exportQrPDF(fileName)} /> */}
                        <Button label="Generate QR" icon="pi pi-plus" style={{ marginRight: '.5em' }} onClick={() => handleCreate()} />

                    </div>
                </div>
            </div>
        );
    };


    const actionTemplate = (rowData: any) => (
        <div style={{ display: 'flex', gap: '5px' }}>
            <Toast ref={toast} position="bottom-center" />
            <Button
                label="Print By Batch"
                icon="pi pi-qrcode"
                className="p-button-warning p-button-sm "
                style={{ padding: '5px 5px', fontSize: '10px' }}
                onClick={() => handlePrintBundle(rowData.qrBatchId)}
            />
        </div>
    );

    const recordFilterTemplate = () => {
        const handleRecordFilterChange = (e: any) => {
            const { id, value } = e.target;
            setRecordFilter({
                ...recordFilter,
                [id]: value
            });
        };


        const handleInputChange = (e: any) => {
            const { id, value } = e.target;
            setRecordFilter({
                ...recordFilter,
                [id]: value
            });
        };

        const handleDropdownChange = (e: any) => {
            const { id, value } = e.target;
            setRecordFilter({
                ...recordFilter,
                [id]: value
            });
        };

        const handleSearch = () => {
            setShouldFetch(true);
        };

        return (
            <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '2em' }}>
                    <div className="p-float-label" style={{ paddingTop: '0.5rem' }}>
                        <Calendar
                            id="dateFrom"
                            value={recordFilter?.dateFrom && typeof recordFilter?.dateFrom !== 'boolean' ? new Date(recordFilter?.dateFrom) : null}
                            onChange={handleRecordFilterChange}
                            dateFormat="dd M yy"
                            showIcon
                            className={isValid ? '' : 'p-invalid'}
                        >
                        </Calendar>
                        <label style={{ paddingTop: '0.2rem' }}>Date From</label>
                    </div>
                    <div className="p-float-label" style={{ paddingTop: '0.5rem', paddingBottom: '0.2rem' }}>
                        <Calendar
                            id="dateTo"
                            value={recordFilter?.dateTo && typeof recordFilter?.dateTo !== 'boolean' ? new Date(recordFilter?.dateTo) : null}
                            onChange={handleRecordFilterChange}
                            dateFormat="dd M yy"
                            showIcon
                        >
                        </Calendar>
                        <label style={{ paddingTop: '0.2rem' }}>Date To</label>
                    </div>
                    <div className="p-float-label" style={{ paddingTop: '0.5rem', paddingBottom: '0.2rem' }}>
                        <Dropdown
                            id="searchBy"
                            value={recordFilter?.searchBy || ''}
                            onChange={handleDropdownChange}
                            options={searchByOptions}
                            optionLabel="label"
                            placeholder="Select One"
                            optionValue="value"
                            showClear
                        >
                        </Dropdown>
                        <label style={{ paddingTop: '0.2rem' }}>Search By</label>
                    </div>
                    <div className="p-float-label" style={{ paddingTop: '0.5rem', paddingBottom: '0.2rem' }}>
                        <InputText
                            id="searchValue"
                            value={recordFilter?.searchValue != null ? String(recordFilter.searchValue) : ''}
                            onChange={handleInputChange}
                        />
                        <label style={{ paddingTop: '0.2rem' }}>Search Value</label>
                    </div>
                    <div>
                        <Button
                            label='Search'
                            icon="pi pi-search"
                            onClick={handleSearch}
                            severity='info'
                        />
                    </div>
                </div>
                {!isValid && (
                    <small id="dateFrom-help" className="p-error">
                        Date From must be earlier than or equal to Date To
                    </small>
                )}

            </div>
        )
    }

    return (
        <div className='grid'>
            <div className='col-12'>
                <div className='card-title'>
                    <h5>QR Generation</h5>
                    <BreadcrumbComponent />
                </div>

                <Sidebar
                    visible={isPopupVisible}
                    onHide={() => setIsPopupVisible(false)}
                    baseZIndex={1000}
                    position="right"
                    style={{ width: '600px' }}
                    showCloseIcon={false}
                >
                    <div className='card-sidebar card-sidebar-blue'>
                        <div className='header-sidebar'>QR Code Generation</div>
                    </div>
                    <div className='card-sidebar '>
                        <div className='col-12'>
                            <div className="p-fluid form-grid-edit grid">
                                <div className="f-field-full">
                                    <label className='f-label-unwrap'>No. of QR to generate</label>
                                    <div className="f-input">
                                        <InputNumber
                                            inputId="noQR"
                                            name="noQR"
                                            showButtons
                                            mode="decimal"
                                            value={noOfQr}
                                            min={0}
                                            max={10}
                                            onValueChange={(e) =>
                                                setNoOfQr(e.value)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <br />
                            </div>
                            <Toolbar end={dialogFooter}></Toolbar>
                        </div>
                    </div>
                </Sidebar>

                <div className='card'>
                    {/* Filter Date From and Date To */}
                    <Toolbar start={recordFilterTemplate}></Toolbar>
                    <div><br></br></div>
                    <>
                        <DataTable
                            value={gridDataSource}
                            showGridlines
                            scrollable
                            scrollHeight='auto'
                            paginator rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            filters={filters}
                            globalFilterFields={['qrBatchId']}
                            header={header}
                            sortField='modifiedDate'
                            sortOrder={-1}
                            expandedRows={ASTQrdetInit}
                            onRowToggle={(e) => setASTQrdetInit(e.data)}
                            rowExpansionTemplate={rowExpansionTemplate}
                            dataKey="qrBatchId"
                        >
                            <Column expander style={{ width: '3em' }} headerClassName="list-header" />
                            <Column
                                header="No."
                                style={{ width: '5%' }}
                                body={(_, { rowIndex }) => rowIndex + 1} // Render row number
                                headerClassName="list-header"
                            ></Column>
                            <Column body={actionTemplate} header="Actions" style={{ width: '20%' }} headerClassName="list-header"></Column>
                            <Column field="insertDate" header="Generated Date" body={(rowData) => new Date(rowData.insertDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', })} headerClassName="list-header"></Column>
                            <Column field="insertBy" header="Generated By" headerClassName="list-header"></Column>
                            <Column field="qrBatchId" header="QR Batch Id" headerClassName="list-header"></Column>
                            {/* <Column field="noOfQr" header="No. of QR" headerClassName="list-header"></Column> */}
                            <Column body={(r) => `${r.assignedQr}/${r.totalQr}`} header="No. of QR" headerClassName="list-header" />

                        </DataTable>
                    </>
                </div>
            </div>
        </div >
    );
};

export default QRList;

